import './index.css'

export async function init() {
  const root = document.documentElement

  if (root.classList?.remove) {
    root.classList.remove('loading')
  } else {
    root.className = ''
  }

  return null
}
